import { useNavigate } from "react-router-dom";
import { useGetUsersQuery } from '../users/usersApiSlice'
import NewNoteForm from "./NewNoteForm";
import useTitle from '../../hooks/useTitle'
import PulseLoader from 'react-spinners/PulseLoader'


export default function NewNote() {
    useTitle('techNotes: New Note')
    const navigate = useNavigate();

    return (
        <section className="p-6 space-y-6">
        {/* Header */}
        <header className="flex items-center justify-between">
            <div>
            <h1 className="text-2xl font-semibold tracking-tight text-gray-900">New Note</h1>
            <p className="text-sm text-gray-500">Create and configure a new project note.</p>
            </div>
            <button
            onClick={() => navigate(-1)}
            className="rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
            Cancel
            </button>
        </header>

        <NewNoteForm />
        </section>
    );
}
